<div class="location-display">
  <!-- Current Location Display -->
  <div class="current-location">
    <div class="flex align-items-center gap-2">
      <i class="pi pi-map-marker text-primary"></i>
      <div>
        <div class="text-sm text-color-secondary">Current Location</div>
        <div class="font-semibold">{{ getCurrentLocationDisplay() }}</div>
        <div *ngIf="currentLocation?.description" class="text-xs text-color-secondary mt-1">
          {{ currentLocation?.description }}
        </div>
      </div>
    </div>
  </div>

  <!-- Info message -->
  <div class="info-message mt-3">
    <div class="flex align-items-start gap-2 p-3 surface-50 border-round">
      <i class="pi pi-info-circle text-color-secondary"></i>
      <div class="text-sm text-color-secondary">
        Please use the old attendant portal to switch locations.
      </div>
    </div>
  </div>
</div>
